var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSwitchDesktop(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 62,
    height: 62,
    viewBox: "0 0 62 62",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2905_1357)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M60.9799 30.1747C61.1454 34.1227 60.8243 38.076 60.0236 41.9455C57.8363 52.2716 51.2134 58.9149 39.931 60.3595C32.4882 61.455 24.9101 61.2207 17.5492 59.6677C14.2725 59.0178 11.2094 57.5612 8.63728 55.4295C6.06514 53.2979 4.06506 50.5586 2.81802 47.4595C0.933014 42.8832 -0.00487315 37.9722 0.0609976 33.0233C-0.150241 28.3022 0.170548 23.5722 1.01731 18.9228C3.19444 9.25801 8.06754 3.8864 17.9562 1.5058C26.2228 -0.498352 34.8486 -0.498352 43.1153 1.5058C53.0243 3.8864 57.9279 9.27836 60.0236 18.9127C60.8545 22.6055 61.1763 26.3947 60.9799 30.1747Z",
    fill: "#BFF4FB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.6973 27.8668V38.2737H42.9711V27.8668C42.9711 23.6618 42.9711 21.5593 41.6647 20.253C40.3584 18.9467 38.2559 18.9467 34.0509 18.9467H26.6174C22.4124 18.9467 20.3099 18.9467 19.0036 20.253C17.6973 21.5593 17.6973 23.6618 17.6973 27.8668Z",
    fill: "#88E2ED",
    stroke: "#007E8C",
    strokeWidth: 1.48669,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.4668 39.4901C15.4668 39.396 15.4668 39.3489 15.4696 39.3092C15.5092 38.7561 15.9492 38.3161 16.5023 38.2765C16.542 38.2737 16.5891 38.2737 16.6832 38.2737H43.9843C44.0784 38.2737 44.1255 38.2737 44.1652 38.2765C44.7183 38.3161 45.1583 38.7561 45.1979 39.3092C45.2007 39.3489 45.2007 39.396 45.2007 39.4901C45.2007 39.741 45.2007 39.8665 45.1931 39.9725C45.0876 41.4475 43.9144 42.6206 42.4395 42.7262C42.3335 42.7338 42.208 42.7338 41.957 42.7338H18.7105C18.4595 42.7338 18.334 42.7338 18.2281 42.7262C16.7531 42.6206 15.5799 41.4475 15.4744 39.9725C15.4668 39.8665 15.4668 39.741 15.4668 39.4901Z",
    fill: "#007E8C",
    stroke: "#007E8C",
    strokeWidth: 1.48669,
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2905_1357"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 61.041,
    height: 61.041,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSwitchDesktop);
export default __webpack_public_path__ + "static/media/switch-desktop.992272f106a2e645af6446e10bef5c89.svg";
export { ForwardRef as ReactComponent };